import React from 'react'

const GoalArea = () => {
    return (
        <div className="goal-area space">
            <div className="container">
                <div className="row align-items-end">
                    <div className="col-lg-6">
                        <div className="title-area">
                            <span className="sub-title">
                                <img src="assets/img/icon/title_left.svg" alt="shape" />
                                Our Mission
                            </span>
                            <h2 className="sec-title style2">Delivering Excellence in Procurement & Construction</h2>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="goal-title-area">
                            <p className="">
                                A modern approach to procurement, services, and construction. We uphold the highest standards of professionalism and operational excellence across Europe and the Middle East.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="goal-tabs-wrapper">
                        <div
                            className="nav nav-tabs goal-tabs-tabs"
                            id="nav-tab"
                            role="tablist"
                        >
                            <button
                                className="nav-link"
                                id="nav-step1-tab"
                                data-bs-toggle="tab"
                                data-bs-target="#nav-step1"
                                type="button"
                            >
                                About Us
                            </button>
                            <button
                                className="nav-link"
                                id="nav-step2-tab"
                                data-bs-toggle="tab"
                                data-bs-target="#nav-step2"
                                type="button"
                            >
                                Our Services
                            </button>
                            <button
                                className="nav-link active"
                                id="nav-step3-tab"
                                data-bs-toggle="tab"
                                data-bs-target="#nav-step3"
                                type="button"
                            >
                                Our Approach
                            </button>
                            <button
                                className="nav-link"
                                id="nav-step4-tab"
                                data-bs-toggle="tab"
                                data-bs-target="#nav-step4"
                                type="button"
                            >
                                Our Reach
                            </button>
                        </div>
                        <div className="tab-content" id="nav-tabContent">
                            <div className="tab-pane fade" id="nav-step1" role="tabpanel">
                                <div className="goal-list_wrapper">
                                    <div className="goal-content_wrapp">
                                        <img src="assets/img/icon/angles-left.svg" alt="Company" />
                                        <div className="goal-content">
                                            <h4 className="box-title">
                                                Professional Foundation
                                            </h4>
                                            <p>Built on Expertise and Innovation</p>
                                            <div className="checklist">
                                                <ul>
                                                    <li>
                                                        <i className="fas fa-check" />
                                                        Newly established with modern approaches
                                                    </li>
                                                    <li>
                                                        <i className="fas fa-check" />
                                                        Blend of expertise and strategic insight
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="goal-content_wrapp">
                                        <img src="assets/img/icon/angles-left.svg" alt="Company" />
                                        <div className="goal-content">
                                            <h4 className="box-title">Operational Excellence</h4>
                                            <p>Highest Standards in All Operations</p>
                                            <div className="checklist">
                                                <ul>
                                                    <li>
                                                        <i className="fas fa-check" />
                                                        Professionalism at every level
                                                    </li>
                                                    <li>
                                                        <i className="fas fa-check" />
                                                        Quality-driven processes
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="tab-pane fade" id="nav-step2" role="tabpanel">
                                <div className="goal-list_wrapper">
                                    <div className="goal-content_wrapp">
                                        <img src="assets/img/icon/angles-left.svg" alt="Supply Service" />
                                        <div className="goal-content">
                                            <h4 className="box-title">
                                                SUPPLY SERVICE
                                            </h4>
                                            <p>Comprehensive Procurement Solutions</p>
                                            <div className="checklist">
                                                <ul>
                                                    <li>
                                                        <i className="fas fa-check" />
                                                        End-to-end supply chain management
                                                    </li>
                                                    <li>
                                                        <i className="fas fa-check" />
                                                        Reliable and timely delivery
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="goal-content_wrapp">
                                        <img src="assets/img/icon/angles-left.svg" alt="Heavy Equipment" />
                                        <div className="goal-content">
                                            <h4 className="box-title">HEAVY EQUIPMENT SUPPLY</h4>
                                            <p>Industrial-Grade Machinery Solutions</p>
                                            <div className="checklist">
                                                <ul>
                                                    <li>
                                                        <i className="fas fa-check" />
                                                        Premium quality equipment
                                                    </li>
                                                    <li>
                                                        <i className="fas fa-check" />
                                                        Maintenance and support services
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="goal-content_wrapp">
                                        <img src="assets/img/icon/angles-left.svg" alt="City Works" />
                                        <div className="goal-content">
                                            <h4 className="box-title">
                                                CITY WORKS
                                            </h4>
                                            <p>Urban Development and Infrastructure</p>
                                            <div className="checklist">
                                                <ul>
                                                    <li>
                                                        <i className="fas fa-check" />
                                                        Municipal project expertise
                                                    </li>
                                                    <li>
                                                        <i className="fas fa-check" />
                                                        Sustainable urban solutions
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="goal-content_wrapp">
                                        <img src="assets/img/icon/angles-left.svg" alt="Personnel Supply" />
                                        <div className="goal-content">
                                            <h4 className="box-title">PERSONEL SUPPLY</h4>
                                            <p>Skilled Workforce Solutions</p>
                                            <div className="checklist">
                                                <ul>
                                                    <li>
                                                        <i className="fas fa-check" />
                                                        Qualified professionals
                                                    </li>
                                                    <li>
                                                        <i className="fas fa-check" />
                                                        Industry-specific expertise
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="goal-content_wrapp">
                                        <img src="assets/img/icon/angles-left.svg" alt="Construction" />
                                        <div className="goal-content">
                                            <h4 className="box-title">CONSTRUCTION</h4>
                                            <p>Comprehensive Building Services</p>
                                            <div className="checklist">
                                                <ul>
                                                    <li>
                                                        <i className="fas fa-check" />
                                                        End-to-end construction management
                                                    </li>
                                                    <li>
                                                        <i className="fas fa-check" />
                                                        Quality and safety focused
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                className="tab-pane fade active show"
                                id="nav-step3"
                                role="tabpanel"
                            >
                                <div className="goal-list_wrapper">
                                    <div className="goal-content_wrapp">
                                        <img src="assets/img/icon/angles-left.svg" alt="Tailored Solutions" />
                                        <div className="goal-content">
                                            <h4 className="box-title">
                                                Customized Service Approach
                                            </h4>
                                            <p>Meeting Complex Project Demands</p>
                                            <div className="checklist">
                                                <ul>
                                                    <li>
                                                        <i className="fas fa-check" />
                                                        Project-specific solutions
                                                    </li>
                                                    <li>
                                                        <i className="fas fa-check" />
                                                        Flexible service models
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="goal-content_wrapp">
                                        <img src="assets/img/icon/angles-left.svg" alt="Quality Focus" />
                                        <div className="goal-content">
                                            <h4 className="box-title">Quality Assurance</h4>
                                            <p>Excellence in Every Delivery</p>
                                            <div className="checklist">
                                                <ul>
                                                    <li>
                                                        <i className="fas fa-check" />
                                                        Rigorous quality control
                                                    </li>
                                                    <li>
                                                        <i className="fas fa-check" />
                                                        Precision execution
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="goal-content_wrapp">
                                        <img src="assets/img/icon/angles-left.svg" alt="Sustainability" />
                                        <div className="goal-content">
                                            <h4 className="box-title">
                                                Sustainable Growth
                                            </h4>
                                            <p>Long-Term Impact Focus</p>
                                            <div className="checklist">
                                                <ul>
                                                    <li>
                                                        <i className="fas fa-check" />
                                                        Environmentally conscious practices
                                                    </li>
                                                    <li>
                                                        <i className="fas fa-check" />
                                                        Future-ready solutions
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="tab-pane fade" id="nav-step4" role="tabpanel">
                                <div className="goal-list_wrapper">
                                    <div className="goal-content_wrapp">
                                        <img src="assets/img/icon/angles-left.svg" alt="Global Reach" />
                                        <div className="goal-content">
                                            <h4 className="box-title">
                                                European Operations
                                            </h4>
                                            <p>Strategic Presence Across Europe</p>
                                            <div className="checklist">
                                                <ul>
                                                    <li>
                                                        <i className="fas fa-check" />
                                                        Local market expertise
                                                    </li>
                                                    <li>
                                                        <i className="fas fa-check" />
                                                        Regional compliance knowledge
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="goal-content_wrapp">
                                        <img src="assets/img/icon/angles-left.svg" alt="Middle East" />
                                        <div className="goal-content">
                                            <h4 className="box-title">Middle East Presence</h4>
                                            <p>Strong Regional Footprint</p>
                                            <div className="checklist">
                                                <ul>
                                                    <li>
                                                        <i className="fas fa-check" />
                                                        Cultural and business understanding
                                                    </li>
                                                    <li>
                                                        <i className="fas fa-check" />
                                                        Local partnership network
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default GoalArea